import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { HelpScreenComponent } from './help-screen-component';
export const HelpScreen: NavigationScreen<'help'> = withErrorBoundary(HelpScreenComponent);
